export const AI_TOOLS_OPEN_EVENT = "excalidraw:open-ai-tools";

